import React from 'react';
import { SelectField, TextField } from 'react-admin';
import PropTypes from 'prop-types';
import EjectedDatagrid from '../../../components/ejected/Datagrid';
import TextFieldWithDate from '../../../components/TextFieldWithDate';
import EjectedBooleanField from '../../../components/ejected/BooleanField';

const Datagrid = ({
  create, edit, total, companies, callcenters, roles, ...rest
}) => (
  <EjectedDatagrid
    currentSort={{ order: 'ASC' }}
    create={create}
    edit={edit}
    {...rest}
  >
    <TextField source="number" label="#" customstyles={{ width: '36px', backgroundColor: '#2c9bc3' }} />
    <TextField source="name" label="Имя" customstyles={{ width: '100px', backgroundColor: '#2c9bc3' }} />
    <SelectField source="role" label="Роль" customstyles={{ width: '100px', backgroundColor: '#2c9bc3' }} choices={roles} />
    <TextField source="email" label="Email" customstyles={{ width: '150px', backgroundColor: '#2c9bc3' }} />
    <TextField source="fee_multiply" label="Коэф. Зп" customstyles={{ width: '60px', backgroundColor: '#2c9bc3' }} />
    <SelectField
      label="ЮрКомпания"
      source="companyId"
      choices={companies}
      customstyles={{
        width: '110px', backgroundColor: '#2c9bc3'
      }}
    />
    <SelectField
      label="Колцентр"
      source="callcenterId"
      choices={callcenters}
      customstyles={{
        width: '110px', backgroundColor: '#2c9bc3'
      }}
    />
    <EjectedBooleanField
      source="fired"
      label="Уволен"
      customstyles={{
        background: '#B29C6A',
        width: '70px'
      }}
      color="#B29C6A"
    />
    <TextFieldWithDate source="lastAction" isDate label="Посл. Вход" customstyles={{ textAlign: 'left', width: '100px', backgroundColor: '#2c9bc3' }} />
  </EjectedDatagrid>
);

Datagrid.defaultProps = {
  edit: null,
  create: null,
  companies: [],
  callcenters: [],
  roles: []
};

Datagrid.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
  companies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  callcenters: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  roles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }))
};

export default Datagrid;



// WEBPACK FOOTER //
// ./src/pages/admin/users/Datagrid.js